var React = require('react');

function Medical (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.8 57.8H20c-.6 0-1-.4-1-1v-18H1c-.6 0-1-.4-1-1V20c0-.6.4-1 1-1h18V1c0-.6.4-1 1-1h17.9c.6 0 1 .4 1 1v18h18c.6 0 1 .4 1 1v17.9c0 .6-.4 1-1 1h-18v18c-.1.5-.5.9-1.1.9zm-16.8-2h15.9v-18c0-.6.4-1 1-1h18V21h-18c-.6 0-1-.4-1-1V2H21v18c0 .6-.4 1-1 1H2v15.9h18c.6 0 1 .4 1 1v17.9z"}));
}

Medical.defaultProps = {"fill":"currentColor","viewBox":"0 0 57.8 57.8"};

module.exports = Medical;

Medical.default = Medical;
